import React from 'react';
import styled from 'styled-components';
import { useWiserTheme } from '../../hooks/useWiserTheme';

const FooterContainer = styled.footer`
  padding: 0.7rem 0;
  text-align: center;
  width: 100%;
  margin-top: auto;
`;

const FooterContent = styled.div<{ $color: string }>`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  color: ${({ $color }) => $color};
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const CopyrightText = styled.span`
  opacity: 0.9;
`;

const CompanyName = styled.span<{ $color: string }>`
  font-weight: 600;
  color: ${({ $color }) => $color};
`;

const Footer: React.FC = () => {
  const { darkModeActive, tokens } = useWiserTheme();
  const textColor = darkModeActive ? tokens.textPrimary : '#384B7B';
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent $color={textColor}>
        <CopyrightText>© {currentYear} Tüm hakları</CopyrightText>
        <CompanyName $color={textColor}>RDC Partner</CompanyName>
        <CopyrightText>'a aittir.</CopyrightText>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
